import { render, staticRenderFns } from "./kr-file-picture.vue?vue&type=template&id=0bc2d90f&scoped=true&"
import script from "./kr-file-picture.vue?vue&type=script&lang=js&"
export * from "./kr-file-picture.vue?vue&type=script&lang=js&"
import style0 from "./kr-file-picture.vue?vue&type=style&index=0&id=0bc2d90f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2d90f",
  null
  
)

export default component.exports